import { render, staticRenderFns } from "./adduserviews.vue?vue&type=template&id=c3d8b9b2"
import script from "./adduserviews.vue?vue&type=script&lang=js"
export * from "./adduserviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports